import { gql } from 'apollo-boost';

export const BUSINESS_DETAIL_GQL = gql`
  query Business($businessId: ID!) {
    business(id: $businessId) {
      id
      active
      name
      street_1
      street_2
      city
      state
      zip
      phone_number
      allow_dancer_reviews
      business_features {
        auditions
        bookings
        audition_limits {
          applications_max
          duration_max
        }
        managers {
          shift_period_filters{
            value
            unit
            default
          }
        }
      }
      organization {
        id
      }
      required_documents
      square_footage
      number_of_stages
      special_requirements_link
      url
      notes
      audition_info
      min_dancers_for_free_agent_search
      max_consecutive_shift_count
      allow_under_21_dancers
      free_agent_search_enabled
      dancer_count
      profile_options {
        id
      }
      hours_of_operation {
        all_day
        open
        close
        closed
        day
        id
      }
      first_image {
        id
        thumb
        medium
      }
      images {
        id
        thumb
        medium
        position
      }
      timezone
      latitude
      longitude
      tier
      auditions_enabled
      message_club
      audition_duration_max
      audition_applications_max
      auditions_daily_max
      business_group {
        id
        name
      }
    }
  }
`;
